const editCheckoutTermsConditionsConstantsAr = {
  checkoutTermsConditionsPageTitle: 'شروط وأحكام عملية الشراء - تعديل',
  checkoutTermsConditionsBreadcrumb: 'شروط وأحكام عملية الشراء',
};

export default editCheckoutTermsConditionsConstantsAr;
